import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import api, { money, formatApiError } from "../lib/api";

export default function SimulatedPayPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/orders/${id}`)
      .then((r) => {
        if (r.data.status === "paid") navigate(`/pedido/${id}`, { replace: true });
        else setOrder(r.data);
      })
      .catch(() => setError("Pedido não encontrado"));
  }, [id, navigate]);

  const pay = async () => {
    setLoading(true);
    try {
      await api.post("/dev/simulate-payment", { order_id: id });
      navigate(`/pedido/${id}`, { replace: true });
    } catch (e) {
      toast.error(formatApiError(e, "Falha ao simular pagamento"));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="simulated-pay-page">
      <div className="w-full max-w-md border border-gold/25 rounded-lg bg-[#111111] p-10 text-center gold-glow">
        <p className="label-caps mb-3">Modo simulação</p>
        <h1 className="font-display text-3xl tracking-tight mb-2">Pagamento InfinitePay</h1>
        <p className="text-xs text-zinc-500 mb-8">Ambiente de teste — nenhuma cobrança real será feita.</p>

        {error && <p className="text-red-400 text-sm" data-testid="sim-error">{error}</p>}

        {order && (
          <>
            <div className="border border-white/10 rounded-md p-5 mb-8 text-left space-y-2 text-sm">
              {order.items.map((i, idx) => (
                <div key={idx} className="flex justify-between text-zinc-300">
                  <span>{i.quantity}× {i.name}</span>
                  <span>{money(i.unit_price * i.quantity)}</span>
                </div>
              ))}
              <div className="flex justify-between pt-3 border-t border-white/10">
                <span>Total</span>
                <span className="text-gold font-semibold" data-testid="sim-total">{money(order.total)}</span>
              </div>
            </div>
            <Button onClick={pay} disabled={loading} data-testid="simulate-pay-button"
              className="w-full bg-gold text-black hover:bg-gold-light font-semibold h-12 transition-colors">
              {loading ? "Processando..." : "Simular pagamento aprovado"}
            </Button>
            <Link to="/" className="block text-xs text-zinc-500 hover:text-gold mt-5 transition-colors" data-testid="sim-cancel-link">Cancelar e voltar à loja</Link>
          </>
        )}
      </div>
    </div>
  );
}
